import React from "react";
import Header from "./Header";
import Hero from "./Hero";
import BraveryBoost from "./BraveryBoost";
import EmpowerWho from "./EmpowerWho";
import Mission from "./Mission";
import Testimonial from "./Testimonial";
import ThemeSong from "./ThemeSong";
import KidOfTheWeek from "./KidOfTheWeek";
import Videos from "./Videos";
import FutureVideos from "./FutureVideos";
import Values from "./Values";
import EmpowerBand from "./EmpowerBand";
import ScareCTA from "./ScareCTA";
import ShopSection from "./ShopSection";
import CourageCart from "./CourageCart";
import TeamBraveMe from "./TeamBraveMe";
import Footer from "./Footer";
import { testimonials } from "../mock";

const LandingPage = () => {
  return (
    <div className="bg-white">
      <Header />
      <main>
        <Hero />
        <Videos />
        <BraveryBoost />
        <EmpowerWho />
        <Mission />
        <Testimonial data={testimonials[0]} />
        <TeamBraveMe />
        <ShopSection />
        <FutureVideos />
        <Testimonial data={testimonials[1]} />
        <Values />
        <ThemeSong />
        <KidOfTheWeek />
        <EmpowerBand />
        <ScareCTA />
      </main>
      <Footer />
      <CourageCart />
    </div>
  );
};

export default LandingPage;
